import React from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from '@material-ui/core/Select';
import moment from 'moment'
import Switch from "@material-ui/core/Switch";


import PrototypeExploreAssignUser from '../../views/Explore/PrototypeExploreAssignUser.jsx';



const PartyDetails = (props) => {
    const locationTypes = ['', 'Business', 'Construction Site', 'Convention Center or Tradeshow', 'Freight Carrier Terminal', 'Home Based Business', 'Mlitary Base', 'Mini-Storage / Self Storage Facility', 'Religious Institution', 'Residential / Home'];
    const { arr, businessQuery, userQuery, classes, assignBusiness, handleNotificationsToggle, assignUser, arrString, locationType, handleChange, handleArrChange, handleSelectChangeObj } = props;
    console.log(arr)
    return (
        <GridContainer>
            <GridItem xs={12} md={6}>
                <GridContainer>
        <GridItem xs={12}>
        Customer Notifications?
                <Switch
                              checked={arr && arr["notifications"]}
                              onChange={(e) => handleNotificationsToggle(e, arrString)}
                              classes={{
                                switchBase: classes.switchBase,
                                checked: classes.switchChecked,
                                icon: classes.switchIcon,
                                iconChecked: classes.switchIconChecked,
                                bar: classes.switchBar,
                              }}
                            />
        </GridItem>
                    <GridItem xs={12}>

                        <PrototypeExploreAssignUser
                            labelText={"Search Business Name"}
                            collection={"haney-shippers"}
                            id={"businessQuery"}
                            onChange={handleChange}
                            value={businessQuery ? businessQuery : ''}
                            assignUser={assignBusiness}
                            stateObj={arrString}
                        />

                    </GridItem>

                    <GridItem xs={12}>

                        <CustomInput
                            labelText="Business Name"
                            id="businessName"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                required: true,
                                type: "text",
                                onChange: (event) => handleArrChange(event, arrString),
                                value: arr ? arr['businessName'] : ''
                            }}
                        />

                    </GridItem>

                    <GridItem xs={12}>


                        <CustomInput
                            labelText="Address"
                            id="address"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                required: true,
                                type: "text",
                                onChange: (event) => handleArrChange(event, arrString),
                                value: arr ? arr['address'] : ''
                            }}
                        />

                    </GridItem>

                    <GridItem xs={4}>
                        <CustomInput
                            labelText="City"
                            id="city"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                required: true,
                                type: "text",
                                onChange: (event) => handleArrChange(event, arrString),
                                value: arr ? arr['city'] : ''
                            }}
                        />
                    </GridItem>
                    <GridItem xs={4}>
                        <CustomInput
                            labelText="State"
                            id="state"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                required: true,
                                type: "text",
                                onChange: (event) => handleArrChange(event, arrString),
                                value: arr ? arr['state'] : ''
                            }}
                        />
                    </GridItem>
                    <GridItem xs={4}>
                        <CustomInput
                            labelText="Zip"
                            id="zip"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                required: true,
                                type: "text",
                                onChange: (event) => handleArrChange(event, arrString),
                                value: arr ? arr['zip'] : ''
                            }}
                        />
                    </GridItem>

                    <GridItem xs={12}>
                        {locationType ? <FormControl
                            fullWidth
                            className={classes.selectFormControl}>
                            <InputLabel
                                htmlFor="type"
                                className={classes.selectLabel}>
                                LOCATION TYPE:
                            </InputLabel>
                            <Select
                                MenuProps={{
                                    className: classes.selectMenu
                                }}
                                classes={{
                                    select: classes.select
                                }}
                                value={arr['type']}
                                onChange={(e) => handleSelectChangeObj(e, arrString)}
                                defaultValue={arr['type'] ? arr['type'] : ''}
                                inputProps={{
                                    id: 'type',
                                    name: 'type'
                                }}
                            >
                                {
                                    locationTypes.map((item) => (
                                        <MenuItem
                                            classes={{
                                                root: classes.selectMenuItem
                                            }}
                                            value={item}
                                            key={item}
                                        >{item}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl> :
                            <CustomInput
                                labelText="Reference #"
                                id="referenceID"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                labelProps={{
                                    shrink: true
                                }}

                                inputProps={{
                                    required: true,
                                    type: "text",
                                    onChange: (event) => handleArrChange(event, arrString),
                                    value: arr ? arr['referenceID'] : ''
                                }}
                            />
                        }
                    </GridItem>


                </GridContainer>
            </GridItem>
            <GridItem xs={12} md={6}>
                <GridContainer>

                    <GridItem xs={12}>

                        <PrototypeExploreAssignUser
                            labelText={"Search Users"}
                            collection={"haney-shippers"}
                            subCollection={"users"}
                            id={"userQuery"}
                            onChange={handleChange}
                            value={userQuery ? userQuery : ''}
                            hinge={arr ? arr['businessName'] : ''}
                            assignUser={assignUser}
                            stateObj={arrString}
                        />

                    </GridItem>

                    <GridItem xs={6}>

                        <CustomInput
                            labelText="Contact First Name"
                            id="firstName"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                required: true,
                                type: "text",
                                onChange: (event) => handleArrChange(event, arrString),
                                value: arr ? arr['firstName'] : ''
                            }}
                        />

                    </GridItem>

                    <GridItem xs={6}>

                        <CustomInput
                            labelText="Contact Last Name"
                            id="lastName"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                required: true,
                                type: "text",
                                onChange: (event) => handleArrChange(event, arrString),
                                value: arr ? arr['lastName'] : ''
                            }}
                        />

                    </GridItem>

                    <GridItem xs={12}>

                        <CustomInput
                            labelText="Contact Email"
                            id="email"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                required: true,
                                type: "text",
                                onChange: (event) => handleArrChange(event, arrString),
                                value: arr ? arr['email'] : ''
                            }}
                        />

                    </GridItem>

                    <GridItem xs={12}>

                        <CustomInput
                            labelText="Contact Phone"
                            id="phone"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                required: true,
                                type: "text",
                                onChange: (event) => handleArrChange(event, arrString),
                                value: arr ? arr['phone'] : ''
                            }}
                        />

                    </GridItem>

                    <GridItem xs={12}>
                        {locationType ?
                            <CustomInput
                                labelText="Reference #"
                                id="referenceID"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    required: true,
                                    type: "text",
                                    onChange: (event) => handleArrChange(event, arrString),
                                    value: arr ? arr['referenceID'] : ''
                                }}
                            /> : null
                        }

                    </GridItem>

                </GridContainer>
            </GridItem>

        </GridContainer >
    )
}

export default PartyDetails


// WEBPACK FOOTER //
// ./src/components/Forms/ModalPartyDetails.jsx